import React, { useState, useEffect } from "react";
import Container from "../components/container/Container";
import dayjs from "dayjs";
import Header from "../components/navigationBars/Header";
import TrackList from "../components/navigationBars/TrackList";
import UpcomingRacesTable from "../components/tables/UpcomingRacesTable";
import OffRacesTable from "../components/tables/OffRacesTable";
import FieldRaceMessageRMQ from "../constants/FieldRaceMessageRMQ";
import MainFieldsMessageRMQ from "../constants/MainFieldsMessageRMQ";
import FieldEntryMessageRMQ from "../constants/FieldEntryMessageRMQ";
import ErrorCodes from "../constants/ErrorCodes";
import SiteConfig from "../constants/SiteConfig";
import Swal from "sweetalert2";
import { useWebSocket } from "../services/WebSocketProvider";
import { ErrorSessionNoLongerExists } from "../components/utilities/ErrorSessionNoLongerExists";
import ConfirmDialog from "../components/utilities/ConfirmDialog";
import {
  useUpdateFunctions,
  useSelectFunctions,
  useSpecialFunctions,
} from "../functions";

const Dashboard = ({
  data,
  logout,
  getTimeServer,
  setLoading,
  setLoginInfo,
  setLoginInfoUUID,
  publicIP,
}) => {
  const [tracksDate, setTracksDate] = useState(new Date());
  const [upcomingRaces, setUpcomingRaces] = useState([]);
  const [offRaces, setOffRaces] = useState([]);
  const [race, setRace] = useState({});
  const [openTracks, setOpenTracks] = useState([]);
  const [racesTracks, setRacesTracks] = useState([]);
  const [refreshInfo, setRefreshInfo] = useState(false);
  const [refreshEntries, setRefreshEntries] = useState(false);
  const [gameProviders, setGameProviders] = useState([]);
  const [trackCategory, setTrackCategory] = useState([]);
  const [trackCategoryCbx, setTrackCategoryCbx] = useState([]); // this status is used to load the category combo boxes
  const [profiles, setProfiles] = useState([]);
  const [limitSetList, setLimitSetList] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(-1);
  const [upcomingRaceSelected, setUpcomingRaceSelected] = useState(0);
  const [offRaceSelected, setOffRaceSelected] = useState(0);
  const [countries, setCountries] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [entries, setEntries] = useState([]);
  const [config, setConfig] = useState(window.config.RMQConfig.Active);
  const [processedEntries, setProcessedEntries] = useState([]);
  const [processedEntryCreate, setProcessedEntryCreate] = useState([]);
  const [processedPool, setProcessedPool] = useState([]);
  const [resultsList, setResultsList] = useState([]);
  const [sessionNoLongerExists, setSessionNoLongerExists] = useState(false);
  const [readOnlyResults, setReadOnlyResults] = useState([]);
  const [selectedTicketsVoidScore, setSelectedTicketsVoidScore] = useState([]);
  const [
    selectedTicketsVoidScoreContainer,
    setSelectedTicketsVoidScoreContainer,
  ] = useState([]);
  const [selectAllTickets, setSelectAllTickets] = useState(false);
  const [callTicketVoidListFrom, setCallTicketVoidListFrom] = useState({});
  const { ticketVoidList, scoreTicketList } = useUpdateFunctions();
  const {
    getActiveTracksDate,
    getRaces,
    getUpcomingRaces,
    getRacesOff,
    getRace,
    getGameProviders,
    getTrackCategoryList,
    getProfilesList,
    getLimitsSetList,
    getCountriesList,
    getAllStatesList,
    getSystemPreferencesRacing,
  } = useSelectFunctions();
  const { getTimeInfo, getDateInfo } = useSpecialFunctions();
  const [changeProviderFilter, setChangeProviderFilter] = useState(false);
  const [callPastPostMethod, setCallPastPostMethod] = useState(false); //Used to update score/unscore past posts from the possiblePastPost modal.
  const [systemPreferences, setSystemPreferences] = useState({
    IntervalPastPost: "",
    PickRulesEnabled: false,
    TrackTypesEnabled: 0,
    TrackPackages: [],
    UpgradeEnabled: false,
  });

  //User Rights List
  const userRightsList = JSON.parse(localStorage.getItem("UserRights")) || [];

  const {
    raceChangesMessageRMQ,
    selectOption,
    setRaceChangesMessageRMQ,
    raceChangesMessageTrackList,
    setRaceChangesMessageTrackList,
    resultCreateMessageRMQ,
    setResultCreateMessageRMQ,
    entriesMessageRMQ,
    setEntriesMessageRMQ,
    raceCreateMessageRMQ,
    setRaceCreateMessageRMQ,
    entryCreateMessageRMQ,
    setEntryCreateMessageRMQ,
    poolMessageRMQ,
    setPoolMessageRMQ,
    setOptions,
    stateTracks,
    setStateTracks,
    callGetActiveTracks,
    setCallGetActiveTracks,
    packagesMessageRMQ,
    setPackagesMessageRMQ,
  } = useWebSocket();

  const sortByMTP = (races) => {
    return [...races].sort((a, b) => {
      const isPostA = a.MTP === -128;
      const isPostB = b.MTP === -128;

      if (isPostA && !isPostB) return -1;
      if (!isPostA && isPostB) return 1;

      return a.MTP - b.MTP;
    });
  };

  //#region RMQ
  // Processes messages received from RMQ for the RaceChange,
  useEffect(() => {
    if (config && raceChangesMessageRMQ.length !== 0) {
      const processRaces = async () => {
        const upRaceMessageRMQ = [...raceChangesMessageRMQ];
        const racesMessageToRemove = [];

        const dataRaces = upRaceMessageRMQ[0];
        const processDate = getDateInfo(dataRaces.ProcessDateTime);
        const dateTracks = getDateInfo(tracksDate);

        if (processDate !== dateTracks) {
          return;
        }

        while (upRaceMessageRMQ.length > 0) {
          const dataRaces = upRaceMessageRMQ[0];

          if (dataRaces.Changes) {
            dataRaces.Changes.forEach((change, i) => {
              //Change Field MTP
              if (change.Field === MainFieldsMessageRMQ.MTP.name) {
                if (parseInt(change.NewValue) >= 0) {
                  if (upcomingRaces) {
                    upcomingRaces.forEach((upRace, i) => {
                      if (upRace.RaceID === dataRaces.RaceID) {
                        upRace.MTP = parseInt(change.NewValue);
                      }
                    });
                  }

                  const upRaceExists = upcomingRaces.some(
                    (upRace) => upRace.RaceID === dataRaces.RaceID,
                  );

                  if (selectOption.raceID) {
                    if (selectOption.raceID === dataRaces.RaceID) {
                      race.MTP = parseInt(change.NewValue);
                    }
                  }

                  if (racesTracks) {
                    racesTracks.forEach((raceT, i) => {
                      raceT.forEach((race, i) => {
                        if (race.RaceID === dataRaces.RaceID) {
                          race.MTP = parseInt(change.NewValue);
                        }
                      });
                    });
                  }

                  if (!upRaceExists) {
                    upcomingRaces.push({
                      RaceID: dataRaces.RaceID,
                      TrackCode: dataRaces.TrackCode,
                      RaceNumber: dataRaces.RaceNumber,
                      MTP: parseInt(change.NewValue),
                      PostTime: dataRaces.PostTime,
                      TrackID: dataRaces.TrackID,
                    });
                    setUpcomingRaces(sortByMTP(upcomingRaces));
                  }
                } else {
                  if (upcomingRaces) {
                    const updatedUpcoming = upcomingRaces.filter(
                      (item) => item.RaceID !== dataRaces.RaceID,
                    );

                    setUpcomingRaces(sortByMTP(updatedUpcoming));
                  }

                  if (racesTracks) {
                    racesTracks.forEach((raceT) => {
                      raceT.forEach((race) => {
                        if (race.RaceID === dataRaces.RaceID) {
                          race.MTP = -128;
                        }
                      });
                    });
                  }

                  if (selectOption.raceID === dataRaces.RaceID) {
                    race.MTP = "";
                  }
                }
              }

              //Change Field RaceStatus
              if (change.Field === MainFieldsMessageRMQ.RaceStatus.name) {
                if (change.NewValue === "B") {
                  if (upcomingRaces) {
                    if (
                      upcomingRaces.some(
                        (race) => race.RaceID === dataRaces.RaceID,
                      )
                    ) {
                      // The race ID exists in upcomingRaces, execute the following code
                      const raceIDToMove = dataRaces.RaceID;

                      // Filter and delete upcomingRaces item
                      const updatedUpcomingRaces = upcomingRaces.filter(
                        (race) => race.RaceID !== raceIDToMove,
                      );

                      // Find the item you want to move
                      const raceToMove = upcomingRaces.find(
                        (race) => race.RaceID === raceIDToMove,
                      );

                      // Add item to offRaces if found
                      if (raceToMove) {
                        raceToMove.OffTime = "";
                        const updatedOffRaces = [...offRaces, raceToMove];

                        setUpcomingRaces(sortByMTP(updatedUpcomingRaces));
                        setOffRaces(updatedOffRaces);
                      }
                    }
                  }
                }

                if (change.NewValue === "B") {
                  let offTime = "";

                  if (
                    offRaces.some((race) => race.RaceID !== dataRaces.RaceID)
                  ) {
                    offRaces.push({
                      RaceID: dataRaces.RaceID,
                      TrackCode: dataRaces.TrackCode,
                      RaceNumber: dataRaces.RaceNumber,
                      PostTime: dataRaces.PostTime,
                      OffTime: offTime,
                      TrackID: dataRaces.TrackID,
                    });
                  }

                  const uniqueOffRaces = Array.from(
                    new Set(offRaces.map((race) => race.RaceID)),
                  ).map((raceId) => {
                    return offRaces.find((race) => race.RaceID === raceId);
                  });

                  setOffRaces(uniqueOffRaces);
                }

                if (change.NewValue === "C") {
                  const offRaceID = dataRaces.RaceID;

                  const updatedOffRaces = offRaces.filter(
                    (race) => race.RaceID !== offRaceID,
                  );
                  setOffRaces(updatedOffRaces);
                }

                if (change.NewValue === "O") {
                  if (
                    offRaces.some((race) => race.RaceID === dataRaces.RaceID)
                  ) {
                    const offRacesF = offRaces.filter(
                      (race) => race.RaceID !== dataRaces.RaceID,
                    );
                    setOffRaces(offRacesF);
                  }
                }

                if (selectOption.raceID) {
                  if (selectOption.raceID === dataRaces.RaceID) {
                    race.RaceStatus = change.NewValue;
                  }
                }

                if (racesTracks) {
                  racesTracks.forEach((raceT, i) => {
                    raceT.forEach((race, i) => {
                      if (race.RaceID === dataRaces.RaceID) {
                        race.RaceStatus = change.NewValue;
                      }
                    });
                  });
                }
              }

              //Change Field OffTime
              if (change.Field === MainFieldsMessageRMQ.OffTime.name) {
                if (change.NewValue !== "") {
                  if (offRaces) {
                    offRaces.forEach((offRace, i) => {
                      if (offRace.RaceID === dataRaces.RaceID) {
                        offRace.OffTime = change.NewValue;
                      }
                    });
                  }

                  if (selectOption.raceID) {
                    if (selectOption.raceID === dataRaces.RaceID) {
                      race.OffTimeT = getTimeServer(change.NewValue);
                      race.OffDate = getDateInfo(change.NewValue);
                      race.offTime = change.NewValue;
                    }
                  }
                }
              }

              //Change Field PostTime
              if (change.Field === MainFieldsMessageRMQ.PostTime.name) {
                if (change.NewValue !== "") {
                  if (offRaces) {
                    offRaces.forEach((offRace, i) => {
                      if (offRace.RaceID === dataRaces.RaceID) {
                        offRace.PostTime = change.NewValue;
                      }
                    });
                  }

                  if (selectOption.raceID) {
                    if (selectOption.raceID === dataRaces.RaceID) {
                      race.PostTimeT = getTimeInfo(change.NewValue);
                      race.PostDate = getDateInfo(change.NewValue);
                      race.postTime = change.NewValue;
                    }
                  }
                }
                if (racesTracks && racesTracks.length > 0) {
                  const raceT = racesTracks[0].find(
                    (item) => item.RaceID === dataRaces.RaceID,
                  );

                  if (raceT) {
                    raceT.SystemRaceDateTime = dataRaces.SystemRaceDateTime;
                  }
                }
              }

              //Change Race Info Details
              if (selectOption.raceID) {
                if (selectOption.raceID === dataRaces.RaceID) {
                  let newValue;

                  FieldRaceMessageRMQ.forEach((element) => {
                    if (element.name === change.Field && newValue !== "") {
                      if (element.type === "bool") {
                        newValue = JSON.parse(change.NewValue);
                      } else if (element.type === "int") {
                        newValue = parseInt(change.NewValue);
                      } else {
                        newValue = change.NewValue;
                      }

                      race[element.name] = newValue;
                    }
                  });
                }
              }
            });
          }
          racesMessageToRemove.push(dataRaces.RaceID);
          upRaceMessageRMQ.shift();
        }

        setRaceChangesMessageRMQ((prevEntries) =>
          prevEntries.filter(
            (entry) => !racesMessageToRemove.includes(entry.RaceID),
          ),
        );
      };

      processRaces();
    }
  }, [config, raceChangesMessageRMQ, upcomingRaces, tracksDate]);

  // Processes the messages received from RMQ for the RaceChange and makes the necessary changes to the TrackList.
  useEffect(() => {
    if (config && raceChangesMessageTrackList.length !== 0) {
      const processEntries = async () => {
        const upRaceChangesMessageRMQ = [...raceChangesMessageTrackList];
        const racesToRemove = [];

        const dataRaces = upRaceChangesMessageRMQ[0];
        const processDate = getDateInfo(dataRaces.ProcessDateTime);
        const dateTracks = getDateInfo(tracksDate);

        if (processDate !== dateTracks) {
          return;
        }

        while (upRaceChangesMessageRMQ.length > 0) {
          const dataRaces = upRaceChangesMessageRMQ[0];
          const updatedTracks = { ...stateTracks };

          if (dataRaces.Changes) {
            dataRaces.Changes.forEach((change) => {
              if (change?.Field === MainFieldsMessageRMQ?.RaceStatus?.name) {
                if (stateTracks.trackList) {
                  updatedTracks.trackList.forEach((track) => {
                    if (track.TrackID === dataRaces.TrackID) {
                      track.Complete = dataRaces.Complete;

                      if (!track.UpcomingRace) {
                        track.UpcomingRace = {};
                      }

                      if (dataRaces.Complete) {
                        track.UpcomingRace.RaceID = 0;
                        track.UpcomingRace.RaceStatus = "";
                        track.UpcomingRace.RaceNumber = 0;
                      } else {
                        track.UpcomingRace.RaceID =
                          dataRaces.UpComingRaceID || 0;

                        track.UpcomingRace.RaceStatus =
                          dataRaces.UpComingRaceStatus || "";

                        track.UpcomingRace.RaceNumber =
                          dataRaces.UpComingRaceNum || 0;
                      }
                    }
                  });

                  setStateTracks(updatedTracks);
                }
              }
            });
          }

          racesToRemove.push(dataRaces.RaceID);
          upRaceChangesMessageRMQ.shift();
        }

        setRaceChangesMessageTrackList((prevEntries) =>
          prevEntries.filter((entry) => !racesToRemove.includes(entry.RaceID)),
        );
      };

      processEntries();
    }
  }, [
    config,
    raceChangesMessageTrackList,
    tracksDate,
    stateTracks,
    racesTracks,
  ]);

  // Processes messages received from RMQ for the result-create
  useEffect(() => {
    if (config && resultCreateMessageRMQ.length !== 0) {
      const processResults = async () => {
        const updatedResultsMessageRMQ = [...resultCreateMessageRMQ];
        const resultsToRemove = [];

        updatedResultsMessageRMQ.forEach((dataRaces) => {
          const processDate = getDateInfo(dataRaces.ProcessDateTime);
          const dateTracks = getDateInfo(tracksDate);

          if (processDate === dateTracks) {
            if (
              selectOption.raceStatus === "C" ||
              selectOption.raceStatus === "B"
            ) {
              setResultsList(dataRaces.Object);
            }
            updatedResultsMessageRMQ.shift();
          }
          resultsToRemove.push(dataRaces.RaceID);
        });

        // Elimina los elementos procesados de la lista
        setResultCreateMessageRMQ((prevRaces) =>
          prevRaces.filter(
            (result) => !resultsToRemove.includes(result.RaceID),
          ),
        );
      };

      processResults();
    }
  }, [config, resultCreateMessageRMQ, tracksDate, selectOption.raceID]);

  // Processes messages received from RMQ for the entry-change
  useEffect(() => {
    if (config && entriesMessageRMQ.length !== 0 && selectOption.raceID) {
      const processEntries = async () => {
        const updatedEntriesMessageRMQ = [...entriesMessageRMQ];

        while (updatedEntriesMessageRMQ.length > 0) {
          const dataEntries = updatedEntriesMessageRMQ[0];
          const processDate = getDateInfo(dataEntries.ProcessDateTime);
          const dateTracks = getDateInfo(tracksDate);

          if (processDate === dateTracks) {
            const updatedEntries = [...entries];

            for (const change of dataEntries.Changes) {
              FieldEntryMessageRMQ.forEach((element) => {
                if (element.name === change.Field) {
                  let newValue;
                  if (element.type === "bool") {
                    newValue = JSON.parse(change.NewValue);
                  } else if (element.type === "int") {
                    newValue = parseInt(change.NewValue);
                  } else {
                    newValue = change.NewValue;
                  }

                  // Update the entry in the copied array
                  const entryToUpdate = updatedEntries.find(
                    (entry) => entry.EntryID === dataEntries.EntryID,
                  );
                  if (entryToUpdate) {
                    entryToUpdate[element.name] = newValue;
                  }
                }
              });
            }

            // Update the state with the modified entries
            setEntries(updatedEntries);

            // Adds the processed item to the status of processed items
            setProcessedEntries((prevProcessedEntries) => [
              ...prevProcessedEntries,
              dataEntries.EntryID,
            ]);

            // Deletes the processed item from the list
            updatedEntriesMessageRMQ.shift();
          }
        }
        setEntriesMessageRMQ((prevEntries) =>
          prevEntries.filter(
            (entry) => !processedEntries.includes(entry.EntryID),
          ),
        );
      };

      processEntries();
    }
  }, [config, entriesMessageRMQ, tracksDate, selectOption.raceID]);

  // Processes messages received from RMQ for the race-create
  useEffect(() => {
    if (config && raceCreateMessageRMQ.length) {
      const processRaces = async () => {
        const updatedRacesMessageRMQ = [...raceCreateMessageRMQ];

        const processedTracks = [];

        updatedRacesMessageRMQ.forEach((dataRaces) => {
          const processDate = getDateInfo(dataRaces.ProcessDateTime);
          const dateTracks = getDateInfo(tracksDate);

          if (
            processDate === dateTracks &&
            openTracks &&
            openTracks.includes(dataRaces.TrackID)
          ) {
            const newElement = {
              ActualCloseMethod: dataRaces.Object.ActualCloseMethod,
              AdvanceEvent: dataRaces.Object.AdvanceEvent,
              Class: dataRaces.Object.Class,
              CloseMethod: dataRaces.Object.CloseMethod,
              DailyDouble: dataRaces.Object.DailyDouble,
              Distance: dataRaces.Object.Distance,
              Exacta: dataRaces.Object.Exacta,
              GrandSlam: dataRaces.Object.GrandSlam,
              High5: dataRaces.Object.High5,
              HouseQ: dataRaces.Object.HouseQ,
              IdGameProvider: dataRaces.Object.IdGameProvider,
              LastModificationUser: dataRaces.Object.LastModificationUser,
              MTP: dataRaces.Object.MTP,
              OffTime: dataRaces.Object.OffTime,
              Omni: dataRaces.Object.Omni,
              Pick3: dataRaces.Object.Pick3,
              Pick4: dataRaces.Object.Pick4,
              Pick5: dataRaces.Object.Pick5,
              Pick6: dataRaces.Object.Pick6,
              Pick7: dataRaces.Object.Pick7,
              Pick8: dataRaces.Object.Pick8,
              Pick9: dataRaces.Object.Pick9,
              Pick10: dataRaces.Object.Pick10,
              Pick11: dataRaces.Object.Pick11,
              Pick12: dataRaces.Object.Pick12,
              PickAll: dataRaces.Object.PickAll,
              Place: dataRaces.Object.Place,
              PostTime: dataRaces.Object.PostTime,
              Purse: dataRaces.Object.Purse,
              Quinella: dataRaces.Object.Quinella,
              RaceDate: dataRaces.Object.RaceDate,
              RaceDesc: dataRaces.Object.RaceDesc,
              RaceDescription: dataRaces.Object.RaceDescription,
              RaceID: dataRaces.Object.RaceID,
              RaceNumber: dataRaces.Object.RaceNumber,
              RaceShortDesc: dataRaces.Object.RaceShortDesc,
              RaceStatus: dataRaces.Object.RaceStatus,
              Show: dataRaces.Object.Show,
              StakeGrade: dataRaces.Object.StakeGrade,
              StakeName: dataRaces.Object.StakeName,
              Superfecta: dataRaces.Object.Superfecta,
              Surface: dataRaces.Object.Surface,
              SystemRaceDateTime: dataRaces.Object.SystemRaceDateTime,
              SystemOffDateTime: dataRaces.Object.SystemOffDateTime,
              TrackCode: dataRaces.Object.TrackCode,
              TrackCond: dataRaces.Object.TrackCond,
              TrackID: dataRaces.Object.TrackID,
              Trifecta: dataRaces.Object.Trifecta,
              Win: dataRaces.Object.Win,
            };

            const trackIndex = racesTracks.findIndex(
              (track) => track[0].TrackID === dataRaces.TrackID,
            );

            if (trackIndex !== -1) {
              racesTracks[trackIndex].push(newElement);
            } else {
              racesTracks.push([newElement]);
            }

            processedTracks.push(dataRaces.RaceID);
          }
        });

        setRaceCreateMessageRMQ((prevRaces) =>
          prevRaces.filter((race) => !processedTracks.includes(race.RaceID)),
        );
      };

      processRaces();
    }
  }, [config, raceCreateMessageRMQ, tracksDate]);

  useEffect(() => {
    if (callGetActiveTracks) {
      getActiveTracks(false);
    }
  }, [callGetActiveTracks]);

  // Processes messages received from RMQ for the entry-create
  useEffect(() => {
    if (config && entryCreateMessageRMQ.length !== 0 && selectOption.raceID) {
      const processEntriesCreate = async () => {
        const createEntryMessageRMQ = [...entryCreateMessageRMQ];

        const processedEntry = [];
        createEntryMessageRMQ.forEach((dataEntry) => {
          const processDate = getDateInfo(dataEntry.ProcessDateTime);
          const dateTracks = getDateInfo(tracksDate);

          if (
            processDate === dateTracks &&
            selectOption.raceID === dataEntry.RaceID
          ) {
            entries.push(dataEntry.Object);
            setEntries(entries);
            processedEntry.push(dataEntry.Object.EntryID);
          }
        });
        setProcessedEntryCreate((prevProcessedEntryCreate) => [
          ...prevProcessedEntryCreate,
          ...processedEntry,
        ]);
        // Deletes the processed item from the list
        setEntryCreateMessageRMQ((prevEntry) =>
          prevEntry.filter(
            (entry) => !processedEntry.includes(entry.Object.EntryID),
          ),
        );
      };
      processEntriesCreate();
    }
  }, [config, entryCreateMessageRMQ, tracksDate, selectOption.raceID]);

  // Processes messages received from RMQ for the pool-crate
  useEffect(() => {
    if (config && poolMessageRMQ.length !== 0 && selectOption.raceID) {
      const processPool = async () => {
        const poolMessageRMQList = [...poolMessageRMQ];

        const processedPoolMsg = [];
        poolMessageRMQList.forEach((dataPool) => {
          const processDate = getDateInfo(dataPool.ProcessDateTime);
          const dateTracks = getDateInfo(tracksDate);

          if (
            processDate === dateTracks &&
            selectOption.raceID === dataPool.RaceID
          ) {
            entries.forEach((entry) => {
              const matchingOdds = dataPool.Object.find(
                (oddsEntry) => oddsEntry.EntryID === entry.EntryID,
              );

              if (matchingOdds) {
                entry.Odds = matchingOdds;
              }
            });
            processedPoolMsg.push(dataPool.Object.EntryID);
            setEntries([...entries]);
          }
        });
        setProcessedPool((prevProcessedPool) => [
          ...prevProcessedPool,
          ...processedPoolMsg,
        ]);

        setPoolMessageRMQ((prevPool) =>
          prevPool.filter(
            (pool) => !processedPoolMsg.includes(pool.Object.EntryID),
          ),
        );
      };

      processPool();
    }
  }, [config, poolMessageRMQ, tracksDate, selectOption.raceID]);

  // Processes messages received from RMQ for the packages
  useEffect(() => {
    if (!config || !packagesMessageRMQ.length) return;

    const processPackages = () => {
      packagesMessageRMQ.forEach((msg) => {
        const processDate = getDateInfo(msg.ProcessDateTime);
        const dateTracks = getDateInfo(tracksDate);

        if (processDate === dateTracks) {
          const trackPackages = msg.Object?.TrackPackages || [];

          setSystemPreferences((prev) => ({
            ...prev,
            TrackPackages: trackPackages,
          }));
        }
      });

      setPackagesMessageRMQ([]);
    };

    processPackages();
  }, [config, packagesMessageRMQ, tracksDate]);

  //#endregion RMQ

  // Here it is checked whether the user is already logged in.
  const isLoggedIn = data.LogonSessionID === 0;
  if (isLoggedIn) {
    logout();
  }

  // Check the active tracks for the indicated date
  const getActiveTracks = async (
    updateChanges,
    saveRace,
    raceID,
    trackID,
    trackName,
    trackCode,
    raceNumber,
  ) => {
    setLoading(true);
    const res = await getActiveTracksDate(
      {
        RaceDate: dayjs(tracksDate).format("MM/DD/YYYY"),
        ProviderID: parseInt(selectedProvider),
      },
      data.LogonSessionID,
    );
    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setCallGetActiveTracks(false);
      setStateTracks({
        ...stateTracks,
        trackList: res.TrackList,
      });
      let thoroughbredListResp = [],
        harnessListResp = [],
        greyListResp = [],
        trackListResp = [];

      if (res.TrackList) {
        res.TrackList.forEach((track) => {
          trackListResp.push(track);
          switch (track.TrackType) {
            case 0:
              thoroughbredListResp.push(track);
              break;
            case 1:
              harnessListResp.push(track);
              break;
            case 2:
              greyListResp.push(track);
              break;
            default:
              return;
          }
        });
      }
      setStateTracks({
        trackList: res.TrackList,
        thoroughbredList: thoroughbredListResp,
        harnessList: harnessListResp,
        greyList: greyListResp,
      });

      if (updateChanges) {
        if (openTracks.includes(trackID)) {
          getRacesTrack(
            trackID,
            saveRace,
            raceID,
            trackName,
            trackCode,
            raceNumber,
          );
        }
      }
    }
    setLoading(false);
  };

  // Onchange Tracks function
  useEffect(() => {
    handleGetUpcomingRaces();
    getOffRaces();
    setOptions(0, "", 0, 0, "", "");
    setRacesTracks([]);
    setOpenTracks([]);
    setStateTracks({
      thoroughbredList: [],
      harnessList: [],
      greyList: [],
      trackList: [],
    });
    getActiveTracks(false);
  }, [tracksDate]);

  // Onchange Tracks function
  useEffect(() => {
    if (changeProviderFilter) {
      getActiveTracks(false);
      handleGetUpcomingRaces();
      getOffRaces();
      setChangeProviderFilter(false);
    }
  }, [selectedProvider]);

  useEffect(() => {
    getActiveTracks(false);
    getOffRaces();
    handleGetUpcomingRaces();
  }, [systemPreferences.TrackTypesEnabled]);

  // This useEffect function updates the local storage information of the TrackInfo element when stateTracks changes
  useEffect(() => {
    localStorage.setItem("TracksInfo", JSON.stringify(stateTracks));
  }, [stateTracks]);

  // Onchange Races of Tracks function
  const getRacesTrack = async (TrackID, saveRace) => {
    const res = await getRaces(
      {
        TrackID: TrackID,
        RaceDate: dayjs(tracksDate).format("YYYY-MM-DD"),
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setRacesTracks((prevState) => {
        const trackIndex = prevState.findIndex(
          (track) => track[0].TrackID === TrackID,
        );
        if (trackIndex !== -1) {
          return prevState.map((track) =>
            track[0].TrackID === TrackID ? res.Races : track,
          );
        }
        return [...prevState, res.Races];
      });

      if (saveRace) {
        if (stateTracks.trackList.find((track) => track.TrackID === TrackID)) {
          document
            .getElementById("idCollapse" + parseInt(TrackID, 10))
            .classList.add("show");

          // This function is responsible for moving the scroll position to the Track opens when clicking on the Track in the DropDownItem.
          const trackElement = document.getElementById(
            "idCollapse" + parseInt(TrackID, 10),
          );
          trackElement.classList.add("show");

          if (trackElement && trackElement.parentNode) {
            const scrollOffset = 50;
            const trackPosition = trackElement.parentNode.offsetTop;
            const scrollToPosition = trackPosition - scrollOffset;

            trackElement.parentNode.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest",
            });

            trackElement.parentNode.scrollTop -= scrollToPosition;
          }
        }
      }
    }
  };

  // Gets the upcoming races for the indicated date
  const handleGetUpcomingRaces = async () => {
    setLoading(true);
    const res = await getUpcomingRaces(
      {
        RaceDate: dayjs(tracksDate).format("YYYY-MM-DD"),
        ProviderID: parseInt(selectedProvider),
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setUpcomingRaces(res.Races);
    }
    setLoading(false);
  };

  // Gets the off races for the indicated date
  const getOffRaces = async () => {
    setLoading(true);

    const res = await getRacesOff(
      {
        RaceDate: dayjs(tracksDate).format("YYYY-MM-DD"),
        ProviderID: parseInt(selectedProvider),
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setOffRaces(res.Races);
    }
    setLoading(false);
  };

  // This hook calls the function only when opening the trackBar
  useEffect(() => {
    if (selectOption.trackID !== 0) {
      getRacesTrack(selectOption.trackID, false);
    }
  }, [selectOption.trackID]);

  useEffect(() => {
    //With selectOption.status the trackID is set in openTracks or deleted.
    if (selectOption.status === "open") {
      setOpenTracks([selectOption.trackID]);
    } else {
      setOpenTracks([]);
    }
  }, [selectOption]);

  // This hook calls the functions at an interval of time assigned in config

  useEffect(() => {
    if (!config) {
      const interval = setInterval(() => {
        handleGetUpcomingRaces();
        getOffRaces();
        getActiveTracks(true);
        stateTracks.trackList.forEach((track) => {
          if (openTracks.includes(track.TrackID)) {
            getRacesTrack(track.TrackID, false);
          }
        });
      }, window.config.RMQConfig.RefreshLapse);

      return () => clearInterval(interval);
    }
  }, [
    config,
    selectOption,
    openTracks,
    racesTracks,
    tracksDate,
    selectedProvider,
    stateTracks,
  ]);

  //Get Providers function
  const getProviders = async () => {
    const res = await getGameProviders(data.LogonSessionID);

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setGameProviders(res.GameProviders);
    }
  };

  //Get Track Category function, to charge combo box Category
  const getTrackCategory = async () => {
    const res = await getTrackCategoryList(data.LogonSessionID);

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setTrackCategory(res.TrackCategoryList);
      setTrackCategoryCbx(res.TrackCategoryList);
    }
  };

  // Get profiles track function
  const getProfiles = async () => {
    const res = await getProfilesList(data.LogonSessionID);

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setProfiles(res.ProfilesTrackList);
    }
  };

  // Get Limit Set List function
  const getLimitSetList = async () => {
    const res = await getLimitsSetList(data.LogonSessionID);

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setLimitSetList(res.Limits);
    }
  };

  // This hook executes the necessary functions when the dashboard component is loaded.
  useEffect(() => {
    getProviders();
    getTrackCategory();
    getProfiles();
    getLimitSetList();
    getCountries();
    getAllStates();
    handleGetSystemPreferencesRacing();
  }, []);

  // This hook executes the GetRace method
  useEffect(() => {
    handleGetRace();
  }, [refreshInfo]);

  const handleGetRace = async () => {
    const res = await getRace(
      {
        RaceID: selectOption.raceID,
      },
      data.LogonSessionID,
    );

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      let mtp = res.Race.MTP;
      if (res.Race.MTP === -128) {
        mtp = "";
      }
      setRace({
        ...res.Race,
        RaceStatusChange: res.Race.RaceStatus,
        PostTimeT: getTimeServer(res.Race.PostTime),
        PostDate: getDateInfo(res.Race.PostTime),
        OffTimeT: getTimeServer(res.Race.OffTime),
        OffDate: getDateInfo(res.Race.OffTime),
        OffDateSystem: getDateInfo(res.Race.SystemOffDateTime),
        OffTimeSystem: getTimeServer(res.Race.SystemOffDateTime),
        TrackCode: selectOption.trackCode,
        MTP: mtp,
      });
    }
  };

  useEffect(() => {
    if (sessionNoLongerExists) {
      ErrorSessionNoLongerExists(localStorage.getItem("userName"));
      setLoginInfo({ LogonSessionID: "" });
      setLoginInfoUUID("");
      const modalBackdrop = document.querySelector(".modal-backdrop");
      if (modalBackdrop) {
        modalBackdrop.parentNode.removeChild(modalBackdrop);
      }
    }
  }, [sessionNoLongerExists]);

  const getCountries = async () => {
    const res = await getCountriesList(data.LogonSessionID);

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setCountries(res.Countries);
    }
  };

  const getAllStates = async () => {
    const res = await getAllStatesList(data.LogonSessionID);

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setAllStates(res.States);
    }
  };

  // This function is used when the user clicks the Void Selected Tickets button in Score/Unscore, Chart
  var headersErrorsList = "<tr><th>Errors List</th></tr>";
  const voidTickets = (callFrom, selectedTickets) => {
    let bodyVoidErrors = [],
      tableVoidErrors = "";
    if (selectedTickets.length > 0) {
      ConfirmDialog(`Do you want to <strong>Void</strong> the tickets?`).then(
        async (result) => {
          if (result.isConfirmed) {
            const res = await ticketVoidList(
              {
                VoidReason: SiteConfig.VOID_REASON,
                TicketList: selectedTickets,
              },
              data.LogonSessionID,
            );

            if (res?.error) {
              if (
                res.Result === ErrorCodes.InvalidSession ||
                res.Result === ErrorCodes.SessionNoLongerExists
              ) {
                setSessionNoLongerExists(true);
              }
              return;
            } else {
              if (res.ErrorsList.length !== 0) {
                res.ErrorsList.forEach((item, i) => {
                  bodyVoidErrors.push(
                    "<tr key={i}><td className='tdTextAlign'>" +
                      item.ErrMsg +
                      "</td></tr>",
                  );
                });
                tableVoidErrors =
                  "<table className='table table-striped table-sm mt-2'><thead>" +
                  headersErrorsList +
                  "</thead><tbody>" +
                  bodyVoidErrors +
                  "</tbody></table>";
              }
              Swal.fire({
                title: "<strong>VOID</strong>",
                html:
                  "<p className='sweetP'>Tickets Count: <strong>" +
                  res.TicketsCount +
                  "</strong></p> <p className='sweetP'>Tickets Non Void Count: <strong>" +
                  res.TicketsNonVoidCount +
                  "</strong></p><p>Tickets Void Count: <strong>" +
                  res.TicketsVoidCount +
                  "</strong></p>" +
                  tableVoidErrors,
              });
              setSelectedTicketsVoidScore([]);
              setSelectedTicketsVoidScoreContainer([]);
              setSelectAllTickets(false);

              if (callFrom === "PPTScoreUnscore") {
                setCallTicketVoidListFrom({ fromScoreUnscorePastPost: true });
              }

              if (callFrom === "OBChart") {
                setCallTicketVoidListFrom({ fromChartOpenBets: true });
              }

              if (callFrom === "OTScoreUnscore") {
                setCallTicketVoidListFrom({
                  fromScoreUnscoreOpenTickets: true,
                });
              }
              if (callFrom === "PPTSHeader") {
                setCallTicketVoidListFrom({
                  fromHeaderPastPost: true,
                });
                setCallPastPostMethod(true);
              }

              if (callFrom === "OTHeader") {
                setCallTicketVoidListFrom({
                  fromHeaderOpenTickets: true,
                });
              }
            }
          }
        },
      );
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Must select at least one ticket!",
      });
    }
  };

  // This function is used when the user clicks the Score Selected Tickets button (Possible Past Post Ticket item and Manually Score Tickets Item)
  const scoreTickets = (callFrom, selectedTickets) => {
    const addMessageErrorResult =
      "THERE ARE NO OFFICIAL RESULTS FOR THE RACE YET";

    let officialResultsMessage = "";

    if (resultsList?.WPSList?.length === 0) {
      officialResultsMessage = `
   
      <p class='sweetP text-danger'>
        <strong>${addMessageErrorResult}</strong>
      </p>
    `;
    }

    let bodyScoredErrors = [],
      tableScoredErrors = "";

    if (selectedTickets.length > 0) {
      ConfirmDialog(
        `Do you want to <strong>Score</strong> the tickets?
       ${officialResultsMessage}`,
        "No",
        "Yes, Score Tickets!",
      ).then(async (result) => {
        if (result.isConfirmed) {
          const res = await scoreTicketList(
            {
              TicketID: selectedTickets,
            },
            data.LogonSessionID,
          );

          if (res?.error) {
            if (
              res.Result === ErrorCodes.InvalidSession ||
              res.Result === ErrorCodes.SessionNoLongerExists
            ) {
              setSessionNoLongerExists(true);
            }
            return;
          } else {
            if (res.ErrorsList.length !== 0) {
              res.ErrorsList.forEach((item, i) => {
                bodyScoredErrors.push(
                  "<tr key={i}><td className='tdTextAlign'>" +
                    item.ErrMsg +
                    "</td></tr>",
                );
              });
              tableScoredErrors =
                "<table className='table table-striped table-sm mt-2'><thead>" +
                headersErrorsList +
                "</thead><tbody>" +
                bodyScoredErrors +
                "</tbody></table>";
            }

            Swal.fire({
              title: "<strong>SCORE</strong>",
              html:
                "<p className='sweetP'>Tickets Count: <strong>" +
                res.TicketsCount +
                "</strong></p> <p className='sweetP'>Tickets Scored Count: <strong>" +
                res.TicketsScoredCount +
                "</strong></p><p>Tickets Unscored Count: <strong>" +
                res.TicketsUnscoredCount +
                "</strong></p>" +
                tableScoredErrors,
            });
            setSelectedTicketsVoidScore([]);
            setSelectedTicketsVoidScoreContainer([]);
            setSelectAllTickets(false);

            if (callFrom === "PPTScoreUnscore") {
              setCallTicketVoidListFrom({ fromScoreUnscorePastPost: true });
            }
            if (callFrom === "OBChart") {
              setCallTicketVoidListFrom({ fromChartOpenBets: true });
            }
            if (callFrom === "OTScoreUnscore") {
              setCallTicketVoidListFrom({
                fromScoreUnscoreOpenTickets: true,
              });
            }
            if (callFrom === "PPTSHeader") {
              setCallTicketVoidListFrom({
                fromHeaderPastPost: true,
              });
              setCallPastPostMethod(true);
            }

            if (callFrom === "OTHeader") {
              setCallTicketVoidListFrom({
                fromHeaderOpenTickets: true,
              });
            }
          }
        }
      });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Must select at least one ticket!",
      });
    }
  };

  // This function is executed when user clicks on the tab Maintenance
  const handleGetSystemPreferencesRacing = async () => {
    const res = await getSystemPreferencesRacing(data.LogonSessionID);

    if (res?.error) {
      if (
        res.Result === ErrorCodes.InvalidSession ||
        res.Result === ErrorCodes.SessionNoLongerExists
      ) {
        setSessionNoLongerExists(true);
      }
      return;
    } else {
      setSystemPreferences({
        IntervalPastPost: parseInt(res.IntervalPastPost),
        PickRulesEnabled: res.PickRulesEnabled,
        TrackTypesEnabled: res.TrackTypesEnabled,
        UpgradeEnabled: res.UpgradeEnabled,
        TrackPackages: res.TrackPackages,
      });
    }
  };

  return (
    <>
      <Header
        logout={logout}
        data={data}
        gameProviders={gameProviders}
        trackCategory={trackCategory}
        setTrackCategory={setTrackCategory}
        getTrackCategory={getTrackCategory}
        trackCategoryCbx={trackCategoryCbx}
        profiles={profiles}
        getProfiles={getProfiles}
        limitSetList={limitSetList}
        getLimitSetList={getLimitSetList}
        setRefreshInfo={setRefreshInfo}
        refreshInfo={refreshInfo}
        setRefreshEntries={setRefreshEntries}
        refreshEntries={refreshEntries}
        setSelectOption={setOptions}
        getActiveTracks={getActiveTracks}
        countries={countries}
        allStates={allStates}
        sessionNoLongerExists={sessionNoLongerExists}
        setSessionNoLongerExists={setSessionNoLongerExists}
        publicIP={publicIP}
        selectedTicketsVoidScore={selectedTicketsVoidScore}
        setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
        selectAllTickets={selectAllTickets}
        setSelectAllTickets={setSelectAllTickets}
        voidTickets={voidTickets}
        callTicketVoidListFrom={callTicketVoidListFrom}
        scoreTickets={scoreTickets}
        userRightsList={userRightsList}
        setCallPastPostMethod={setCallPastPostMethod}
        systemPreferences={systemPreferences}
        setSystemPreferences={setSystemPreferences}
        handleGetSystemPreferencesRacing={handleGetSystemPreferencesRacing}
      />

      <TrackList
        selectOption={selectOption}
        setSelectOption={setOptions}
        tracksDate={tracksDate}
        setTracksDate={setTracksDate}
        stateTracks={stateTracks}
        openTracks={openTracks}
        setOpenTracks={setOpenTracks}
        racesTracks={racesTracks}
        setRefreshInfo={setRefreshInfo}
        refreshInfo={refreshInfo}
        setRefreshEntries={setRefreshEntries}
        refreshEntries={refreshEntries}
        gameProviders={gameProviders}
        selectedProvider={selectedProvider}
        setSelectedProvider={setSelectedProvider}
        setUpcomingRaceSelected={setUpcomingRaceSelected}
        setOffRaceSelected={setOffRaceSelected}
        setResultsList={setResultsList}
        setReadOnlyResults={setReadOnlyResults}
        setSelectAllTickets={setSelectAllTickets}
        setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
        setChangeProviderFilter={setChangeProviderFilter}
        systemPreferences={systemPreferences}
      />

      <div className="pcoded-main-container">
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="row">
                        {/* Column Container */}
                        <div
                          className="col-sm-12 col-lg-9"
                          style={{ paddingLeft: "1px", paddingRight: "2px" }}
                        >
                          {selectOption.raceID !== 0 &&
                            selectOption.trackID !== 0 &&
                            stateTracks.trackList.length !== 0 &&
                            racesTracks && (
                              <Container
                                trackInfo={
                                  stateTracks.trackList.filter(
                                    (item) =>
                                      item.TrackID === selectOption.trackID,
                                  )[0]
                                }
                                raceID={selectOption.raceID}
                                selectOption={selectOption}
                                userInfo={data}
                                stateTracks={stateTracks}
                                setStateTracks={setStateTracks}
                                tracksDate={tracksDate}
                                race={race}
                                setRaceInfo={setRace}
                                racesTracks={racesTracks.find(
                                  (item) =>
                                    item[0].TrackID === selectOption.trackID,
                                )}
                                setRefreshInfo={setRefreshInfo}
                                refreshInfo={refreshInfo}
                                setRefreshEntries={setRefreshEntries}
                                refreshEntries={refreshEntries}
                                entries={entries}
                                setEntries={setEntries}
                                resultsList={resultsList}
                                setResultsList={setResultsList}
                                sessionNoLongerExists={sessionNoLongerExists}
                                setSessionNoLongerExists={
                                  setSessionNoLongerExists
                                }
                                readOnlyResults={readOnlyResults}
                                setReadOnlyResults={setReadOnlyResults}
                                voidTickets={voidTickets}
                                callTicketVoidListFrom={callTicketVoidListFrom}
                                selectedTicketsVoidScore={
                                  selectedTicketsVoidScore
                                }
                                setSelectedTicketsVoidScore={
                                  setSelectedTicketsVoidScore
                                }
                                selectAllTickets={selectAllTickets}
                                setSelectAllTickets={setSelectAllTickets}
                                scoreTickets={scoreTickets}
                                setCallTicketVoidListFrom={
                                  setCallTicketVoidListFrom
                                }
                                setSelectedTicketsVoidScoreContainer={
                                  setSelectedTicketsVoidScoreContainer
                                }
                                selectedTicketsVoidScoreContainer={
                                  selectedTicketsVoidScoreContainer
                                }
                                callPastPostMethod={callPastPostMethod}
                                setCallPastPostMethod={setCallPastPostMethod}
                              />
                            )}
                        </div>
                        {/* Column UpcomingRaces and OffRaces tables */}
                        <div
                          className="col-sm-12 col-lg-3"
                          style={{
                            paddingLeft: "3px",
                            paddingRight: "3px",
                          }}
                        >
                          <div
                            className="containerInformation col-sm-12"
                            id=""
                            style={{
                              minHeight: "calc(92vh - 15px)",
                            }}
                          >
                            <div className="accordion" id="accordionExample">
                              <div className="card">
                                <div
                                  className="card-header"
                                  id="headingTwo"
                                  style={{ backgroundColor: "#e1e1e1" }}
                                  data-toggle="collapse"
                                  data-target="#collapseTwo"
                                  aria-expanded="true"
                                >
                                  <h5 className="mb-0">
                                    <a
                                      className="lead m-t-0"
                                      style={{
                                        textDecoration: "none",
                                        color: "#000000",
                                      }}
                                      href="#!"
                                      data-toggle="collapse"
                                      data-target="#collapseTwo"
                                      aria-expanded="true"
                                    >
                                      Upcoming Races
                                    </a>
                                  </h5>
                                </div>
                                <div
                                  id="collapseTwo"
                                  className="collapse card-body show"
                                  aria-labelledby="headingTwo"
                                  style={{
                                    maxHeight: "calc(40vh - 15px)",
                                    overflow: "auto",
                                  }}
                                >
                                  <UpcomingRacesTable
                                    upcomingRaces={upcomingRaces}
                                    upcomingRaceSelected={upcomingRaceSelected}
                                    setUpcomingRaceSelected={
                                      setUpcomingRaceSelected
                                    }
                                    setOffRaceSelected={setOffRaceSelected}
                                    setRefreshInfo={setRefreshInfo}
                                    refreshInfo={refreshInfo}
                                    setRefreshEntries={setRefreshEntries}
                                    refreshEntries={refreshEntries}
                                    selectOption={selectOption}
                                    setSelectOption={setOptions}
                                  />
                                </div>
                              </div>
                              <div className="card">
                                <div
                                  className="card-header"
                                  id="headingThree"
                                  style={{ backgroundColor: "#e1e1e1" }}
                                  data-toggle="collapse"
                                  data-target="#collapseThree"
                                  aria-expanded="true"
                                >
                                  <h5 className="mb-0">
                                    <a
                                      className="lead m-t-0"
                                      style={{
                                        textDecoration: "none",
                                        color: "#000000",
                                      }}
                                      href="#!"
                                      data-toggle="collapse"
                                      data-target="#collapseThree"
                                      aria-expanded="true"
                                    >
                                      Off Races
                                    </a>
                                  </h5>
                                </div>
                                <div
                                  id="collapseThree"
                                  className="card-body collapse show"
                                  aria-labelledby="headingThree"
                                  style={{
                                    maxHeight: "calc(40vh - 15px)",
                                    overflow: "auto",
                                  }}
                                >
                                  <div className="">
                                    <OffRacesTable
                                      offRaces={offRaces}
                                      offRaceSelected={offRaceSelected}
                                      setOffRaceSelected={setOffRaceSelected}
                                      setUpcomingRaceSelected={
                                        setUpcomingRaceSelected
                                      }
                                      setRefreshInfo={setRefreshInfo}
                                      refreshInfo={refreshInfo}
                                      setRefreshEntries={setRefreshEntries}
                                      refreshEntries={refreshEntries}
                                      selectOption={selectOption}
                                      setSelectOption={setOptions}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
